/**
 * 注册全局的 filter
 */
import Vue from "vue";

import * as custom from "./filters";

Object.entries(custom).forEach(([key, handler]) => {
  Vue.filter(key, handler);
});
